// import Button from "../button/Button";
import "./navBar.scss";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const NavBar = ()=>{
    const [iconType, setIconType] = useState(false)

    const handleClick = () =>{
        setIconType(!iconType);
    }

    const handleShow = ()=>{
        setIconType(false);
    }

    const handleIgnore = ()=>{

    }
    return(
        <div className="navbar">
            <div className="left__navbar">
                <Link to="/"><img src = {require("../../assets/logo.svg").default} alt ="raydron_logo" className="logo"/></Link> 
                <div className={iconType ? "desktop active" : "desktop"}>
                <Link to="/" className="link" ><span className="nav__headings" onClick={iconType? handleShow : handleIgnore}>HOME</span></Link>
                <Link to="/products" className="link"><span className="nav__headings" onClick={iconType? handleShow : handleIgnore}>PRODUCTS</span></Link>
                <Link to="/about" className="link"><span className="nav__headings" onClick={iconType? handleShow : handleIgnore}>ABOUT US</span></Link>
                <Link to="/contact" className="link"><span className="nav__headings" onClick={iconType? handleShow : handleIgnore}>CONTACT US</span></Link>
                </div>
                
            </div>
            <div className="btn"><a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPW btnNav"><span><FontAwesomeIcon icon={faPhoneAlt}/></span><span className="wText">WhatsApp Us</span></button></a> </div>     
            <div className="right__navbar">
               <img src = {require("../../assets/navbar-icon.svg").default} alt ="navbar_icon" className="navbar__icon"/>
            </div>
            <div className="mobile" onClick={handleClick}>
                    {iconType ? <FontAwesomeIcon icon={faTimes} className="close__icon"/> : <FontAwesomeIcon icon={faBars} className="menu__icon"/>}
            </div>  
        </div>

        
    )
}

export default NavBar